import type { CompanySettings } from './types';

import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import type { KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { zodCompanySettingsSchema } from '../useMutationUpdateCompanySettings/validations';

/**
 * Fetches company settings from the API.
 *
 * @deprecated This endpoint is deprecated and shall be replaced by get_company_by_id.
 * @param companyId - The ID of the company to fetch settings for.
 * @param options - Optional Ky request options including signal for aborting the request.
 * @returns The company settings.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Company/operation/get_company_vadmin_settings_vadmin_company__company_id__vadmin_settings_get
 */
export const fetchCompanySettings = async (
  companyId: UUID,
  options?: KyRequestOptions,
) => {
  const response = await vestigasApi
    .get(ENDPOINT.COMPANY.SETTINGS.GET(companyId), {
      ...options,
      validate: { response: zodCompanySettingsSchema },
    })
    .json<CompanySettings>();

  return response;
};
